module.exports = __webpack_public_path__ + "8563e7122be74172f0fc0acc45a996f1.jpg";